import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { borderAnimation, loadingAnimation } from "../../animations/animations";

const loading = {
  minWidth: 0,
  width: "45px",
  height: "45px",
  padding: "0",
  marginLeft: "auto",
  marginRight: "auto",
  transition: "all 0.4s 0.2s cubic-bezier(.9,.1,.1,.9)",
  animation: `${loadingAnimation("#5C61FF")} 2s 0.4s infinite`,
  ":before": {
    display: "none",
  },
};

const primaryButton: SystemStyleObject<Theme> = {
  color: "common.black",
  background: ({ palette }) => palette.gradient.primary,
  padding: ({ spacing }) => `${spacing(1.5)} ${spacing(8)}`,
  borderRadius: ({ spacing }) => spacing(3.125),

  transition: "transform 0.3s ease-out",

  ":hover": {
    background: ({ palette }) => palette.gradient.primary,
    transform: "scale(1.04)",

    ":before": {
      height: "10px",
      bottom: "4px",
    },
  },
  ":before": {
    content: "''",
    display: "inline-block",
    height: "0px",
    position: "absolute",
    bottom: "16px",
    left: "15px",
    right: "15px",
    opacity: 1,
    zIndex: "-1",
    borderRadius: "30em",
    filter: "blur(20px) brightness(0.95)",
    transition: "all 0.3s ease-out",
    background: ({ palette }) => palette.gradient.primary,
  },
  ":active": {
    backgroundColor: "blue.selected",
  },
  ":disabled": {
    backgroundColor: "gray.outline",
    color: "gray.iconActive",
  },
  "&.Mui-disabled": {
    backgroundColor: "gray.outline",
    color: "gray.iconActive",
  },
  "&.MuiButton-sizeSmall": {
    padding: ({ spacing }) => `${spacing(1)} ${spacing(3)}`,
    minWidth: 0,
  },
  " &.isLoading": {
    ...loading,
    "&:after": borderAnimation("#5C61FF", 1.8),
  },
};

export const classes: Record<string, SystemStyleObject<Theme>> = {
  root: {
    minWidth: ({ spacing }) => spacing(17),
    whiteSpace: "nowrap",
    fontWeight: ({ typography }) => typography.fontWeightSemiBold,

    " &.isLoading": loading,
  },
  primary: primaryButton,
  secondary: {
    color: "common.white",
    padding: ({ spacing }) => `${spacing(1.5)} ${spacing(6)}`,
    minWidth: "175px",
    borderRadius: ({ spacing }) => spacing(3.125),
    "&.MuiButton-sizeSmall": {
      padding: ({ spacing }) => `${spacing(1)} ${spacing(2)}`,
      minWidth: 0,
    },
  },
  danger: {
    ...primaryButton,
    backgroundColor: "error.main",
    background: "none",

    "&:hover": {
      backgroundColor: "error.main",
    },

    ":before": {
      display: "none",
    },

    " &.isLoading": {
      ...loading,
      "&:after": borderAnimation("#E24E4E", 1.8),
      animation: `${loadingAnimation("#E24E4E")} 2s 0.4s infinite`,
    },
  },
};
